"use client";

import { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import { useEVMiStore } from "@/store/EVMStoreProvder";

/**
 * Keeps the persisted EVMi store (selected location / business unit) scoped to
 * the currently authenticated user. The store persists to a single localStorage
 * key shared across users on the same browser, so without this guard a new user
 * would inherit the previous user's location and see their stale dashboard data.
 *
 * Whenever the authenticated user id differs from the one the store was stamped
 * with, we reset the selections so the dashboard falls back to the new user's
 * own accessible locations.
 */
export default function EVMiUserGuard() {
  const { user, isAuthenticated } = useAuth();
  const storedUserId = useEVMiStore((state) => state.userId);
  const resetForUser = useEVMiStore((state) => state.resetForUser);

  useEffect(() => {
    if (!isAuthenticated || !user?.id) return;
    if (storedUserId !== user.id) {
      resetForUser(user.id);
    }
  }, [isAuthenticated, user?.id, storedUserId, resetForUser]);

  return null;
}
